import { gql } from "@apollo/client";

const ADD_DOCUMENTS = gql`
  mutation createPlatformDocument(
    $platformPublicId: String
    $isLeaguePage: Boolean
    $isTournamentCalender: Boolean
    $isRankings: Boolean
    $name: String
    $document: Upload
  ) {
    createPlatformDocument(
      createPlatformDocumentInput: {
        platformPublicId: $platformPublicId
        isLeaguePage: $isLeaguePage
        isTournamentCalender: $isTournamentCalender
        isRankings: $isRankings
        name: $name
        document: $document
      }
    ) {
      id
    }
  }
`;
export default ADD_DOCUMENTS;
